<template>
  <div class="app-container">
    <BjDivider right-fixed>{{ $t('billingPage.ManualHistory') }}</BjDivider>
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.Category')" prop="categoryCode">
            <BjSelectLov v-model="queryParams.categoryCode" :option-list="categoryCodeList" :placeholder="$t('chooseText')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
            <el-date-picker id="getWeekDate" v-model="weekDataNow" :picker-options="{ firstDayOfWeek: 1 }" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="handleQuery">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.form.Approval')" prop="categoryCode">
            <BjSelectLov v-model="tabValue2" :option-list="TAB_LIST2" :placeholder="$t('chooseText')" :clearable="false" @change="changeCategoryCode" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd('NORMAL')">{{ $t('billingPage.normal') }}</el-button>
          <el-button type="primary" class="main-btn" @click="onAdd('DISPO_FEE')">{{ $t('billingPage.once') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'transNo'">
                <span style="color: #3173d0;">{{ scope.row.transNo }}</span>
                <BjCopyIcon :copy="scope.row.transNo" />
              </template>
              <template v-else-if="col.prop == 'clientCode'">
                <span style="color: #3173d0;">{{ scope.row.clientCode }}</span>
                <BjCopyIcon :copy="scope.row.clientCode" />
              </template>
              <template v-else-if="col.prop == 'billCategory.name'">
                <span>{{ scope.row.billCategory.name }}</span>
              </template>
              <template v-else-if="col.prop == 'weekyear'">
                {{ scope.row.year }} / {{ scope.row.week }}
              </template>
              <template v-else-if="col.prop == 'gmtCreate'">
                {{ scope.row.gmtCreate | timeFilters(scope.row.gmtCreate) }}
              </template>
              <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <template>
                <el-button type="text" class="edit-btn" @click="onDetail(props.row)">{{ $t('viewText') }}</el-button>
                <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="tabValue2 == 2" v-permission:BillingManualChargeAuditIsPass command="1">{{ $t('auditPassText') }}</el-dropdown-item>
                    <el-dropdown-item v-if="tabValue2 == 2" v-permission:BillingManualChargeAuditIsPass command="2">{{ $t('auditNotPassText') }}</el-dropdown-item>
                    <el-dropdown-item command="3">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item command="4"> {{ $t('delText') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <viewChargeDialog ref="chargeDialogRef" @reject="onReject" @edit="onEdit" />

    <el-dialog :visible.sync="dialogVisible" :before-close="onReset">
      <normal-form v-if="tabValue=='NORMAL'" ref="NormalFormRef" :client-code-list="clientCodeList" :category-code-list="categoryCodeList" />
      <dispo-form v-if="tabValue=='DISPO_FEE'" ref="DispoFormRef" :client-code-list="clientCodeList" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="onReset">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onSave('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { billApi } from '@/api';
import { reviewLocation } from '../invoiceReview/utils';
import NormalForm from './components/NormalForm';
import DispoForm from './components/DispoForm';
import viewChargeDialog from './components/viewChargeDialog';
import pageMiXin from '@/utils/page-mixin.js';
import moment from 'moment';

const year = `${moment().year()}-${moment().isoWeek().toString().padStart(2, '0')}`;
export default {
  name: 'BusinessBillingAdditionalCharge',
  components: {
    NormalForm,
    DispoForm,
    viewChargeDialog
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 8,
      tableData: [],
      queryApi: billApi.getAdditionalChargeList,
      queryParams: {
        categoryCode: null,
        year: year,
      },
      // 下拉搜索列表
      clientCodeList: [],
      categoryCodeList: [],
      // tab页信息
      tabValue: 'NORMAL',
      tabValue2: '1',
      TAB_LIST2: [
        { label: this.$t('ApprovedText2'), value: '1' },
        { label: this.$t('ApprovedPending'), value: '2' },
        { label: this.$t('ApprovedRejected'), value: '3' },
      ],
      labelList1: [
        // { label: this.$t('billingPage.transactionNumber'), prop: 'transNo', isCheck: true, disabled: false, width: 240 },
        { label: this.$t('billingPage.clientCode'), prop: 'clientCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.categoryName'), prop: 'billCategory.name', isCheck: true, disabled: false },
        { label: this.$t('billingPage.quantity'), prop: 'quantity', isCheck: true, disabled: false },
        { label: this.$t('billingPage.total'), prop: 'totalPrice', isCheck: true, disabled: false },
        { label: this.$t('billingPage.YearWeek'), prop: 'weekyear', isCheck: true, disabled: false },
        { label: this.$t('billingPage.gmtCreate'), prop: 'gmtCreate', isCheck: true, disabled: false },
        { label: this.$t('BjDialogListConfig.Operator'), prop: 'createdBy', isCheck: true, disabled: false },
        { label: this.$t('billingPage.description'), prop: 'description', isCheck: true, disabled: false },
        { label: this.$t('ApprovalDescription'), prop: 'auditDescription', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 140 },
      ],
      weekDataNow: new Date(),
      dialogVisible: false,
    };
  },
  computed: {
    labelList() {
      return this.tabValue2 == 3 ? this.labelList1 : this.labelList1.filter(item => item.prop != 'auditDescription');
    }
  },
  watch: {
    'weekDataNow'() {
      this.$nextTick(() => {
        this.queryParams.year = document.querySelector('#getWeekDate').value;
      });
    },
  },
  mounted() {
    this.getClientInfoList();
    this.getAllAdditionalCharges();
  },
  methods: {
    onAdd(name) {
      this.tabValue = name;
      this.dialogVisible = true;
    },
    command(text, row) {
      if ((text === '3' || text === '4') && row.invoiceReviewRequired) { this.$router.push(reviewLocation(row)); return; }
      switch (text) {
        case '1':
            this.onApprove(row);
            break;
        case '2':
            this.$refs.chargeDialogRef.dialogVisible2 = true;
            this.$refs.chargeDialogRef.form.transNo = row.transNo;
            break;
        case '3':
            this.$refs.chargeDialogRef.dialogVisible3 = true;
            this.$refs.chargeDialogRef.form2.transNo = row.transNo;
            break;
        case '4':
            this.onDel(row);
            break;
      }
    },
    onDetail(row) {
      this.$refs.chargeDialogRef.dialogVisible = true;
      billApi.getTransactionDetail({transNo: row.transNo}).then(res => {
        this.$refs.chargeDialogRef.tableData = [res.data];
      });
    },
    onApprove(item) {
      billApi.approveAdditionalCharge({transNo: item.transNo}).then(() => {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      });
    },
    onReject(item) {
      const { transNo, description } = item;
      billApi.rejectAdditionalCharge({ transNo, description }).then(() => {
        this.$refs.chargeDialogRef.close();
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      });
    },
    onEdit(item) {
      const row = (this.$refs.BjPage.tableData || []).find(value => value.transNo === item.transNo);
      if (row && row.invoiceReviewRequired) { this.$refs.chargeDialogRef.close(); this.$router.push(reviewLocation(row)); return; }
      const { transNo, quantity } = item;
      billApi.updateAdditionalChargeDetail({ transNo, quantity }).then(() => {
        this.$refs.chargeDialogRef.close();
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      });
    },
    changeCategoryCode(val) {
      if (val == 1) {
        this.queryApi = billApi.getAdditionalChargeList;
      } else if (val == 2) {
        this.queryApi = billApi.approvalPendingList;
      } else {
        this.queryApi = billApi.approvalRejectedList;
      }
      this.tabValue2 = val;
      setTimeout(() => { this.reFresh(); }, 300);
    },
    // 获取所有客户信息列表
    getClientInfoList() {
      billApi.getClientInfoList().then(res => {
        res.data.forEach(item => {
          item.label = `${item.label} - ${item.value}`;
        });
        this.clientCodeList = res.data;
      });
    },
    // 获取所有增值服务收费项
    getAllAdditionalCharges() {
      billApi.getAllSearchAdditionalCharges().then(res => {
        this.categoryCodeList = res.data;
      });
    },
    // 新增按钮
    onSave() {
      if (this.tabValue == 'NORMAL') {
        this.$refs.NormalFormRef.$refs.form.validate(valid => {
          if (valid) {
            const data = this.$refs.NormalFormRef.form;
            billApi.addAdditionalChargeList(data).then(res => {
              if (res.code === 200) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.onReset();
              }
            });
          }
        });
      } else {
        this.$refs.DispoFormRef.$refs.form.validate(valid => {
          if (valid) {
            const data = this.$refs.DispoFormRef.form;
            billApi.addAdditionalChargeList(data).then(res => {
                if (res.code === 200) {
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.onReset();
                }
            });
          }
        });
      }
    },
    onReset() {
      this.dialogVisible = false;
      if (this.tabValue == 'NORMAL') {
        this.$refs.NormalFormRef?.$refs['form'].resetFields();
        this.$refs.NormalFormRef?.init();
      } else {
        this.$refs.DispoFormRef?.$refs['form'].resetFields();
        this.$refs.DispoFormRef?.init();
      }
    },
    // 删除按钮
    onDel(row) {
      if (row.invoiceReviewRequired) { this.$router.push(reviewLocation(row)); return; }
      billApi.delAdditionalChargeList({transNo: row.transNo}).then(res => {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        setTimeout(() => { this.reFresh(); }, 300);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}

.ts-divider {
  padding: 5px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
